<template>
    <v-card>
        <v-card-title primary-title>
            <v-icon left large>mdi-card-account-phone-outline</v-icon>
            <span class="headline">Contactos del Día</span>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>

          <v-row>
            <v-col class="pb-0 pt-0 " cols="12" md="2">
              <v-menu
                    v-model="menu_fecha_entrega"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="fecha_desde"
                        label="Fecha de Entrega"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="fecha_desde"
                    @input="menu_fecha_entrega = false"
                    ></v-date-picker>
                </v-menu>

            </v-col>

            <v-col cols="3" md="2" outline>
              <v-btn color="primary" depressed @click="consultar()" ><v-icon left>mdi-account-search-outline</v-icon>Consultar</v-btn>
            </v-col>
             <v-col cols="3" md="2" outline>
              <v-btn color="secondary"
                depressed
                v-clipboard:copy="html_pedidos"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError">
                <v-icon left>mdi-content-copy</v-icon>Copiar</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-textarea v-model="html_pedidos" rows=10></v-textarea>
          </v-row>
        </v-card-text>

        <DialogEspera :dialogEspera="dialogEspera"></DialogEspera>

        <SnackbarMensajes v-bind:sb="sb"></SnackbarMensajes>
    </v-card>
</template>

<script>
import moment from 'moment'
import platform from 'platform-detect'
import ApiService from '@/services/ApiService.js'
import SnackbarMensajes from '@/components/SnackbarMensajes.vue'
import DialogEspera from '@/components/DialogEspera.vue'
import axios from 'axios'


export default {
  name: 'ContactosDelDia',
  components: { SnackbarMensajes, DialogEspera },
  data: () => ({
    menu_fecha_entrega: false,
    repartidores: [],
    vendedores: [],
    dialog_fecha_inicio: false,
    fecha_desde: '',
    html_pedidos: '',
    sb: {
      mostrar: false,
      mensaje: '',
      color: 'success',
      timeout: 3000,
      multiline: false,
    },
    isLoading: true,
    dialogEspera: false,
  }),
  computed: {
    canPrint() {
        return !(platform.ios && platform.pwa);

    },
    isDesktop() {
        return platform.desktop
    },
    formTitle() {
        const title = `Pedido #${this.editedItem.id}`;
        return platform.desktop ? title + ` - ${this.editedItem.vendedor_nombre } - R: ` + (this.editedItem.repartidor ? this.editedItem.repartidor.nombre : '') : title;
    },
  },
  methods: {
    consultar() {
      this.dialogEspera = true;

      const filtros = {
        fecha: this.fecha_desde,
      }
      
      ApiService.getPedidosDelDia(this.$store.getters.token, filtros)
        .then(response => {
            if (response.status == 200) {
                // console.log(response.data.pedidos);
                this.html_pedidos = response.data.pedidos;
                this.dialogEspera = false;
            } else {
                this.showMensaje(
                    `Error al obtener listado ${response.status} - ${response.statusText} `,
                    'error', true)
            }
        })
        .catch(error => {
            if (error.response) this.showMensaje(
                `Error al obtener listado ${error.response.status} - ${error.response.statusText}`,
                'error', true)
            else this.showMensaje(`Error al obtener listado ${error.message}`, 'error', true)
            this.dialogEspera = false
        })
        .finally(() => (this.dialogEspera = false))
    },
    onCopy() {
        this.showMensaje(`Texto copiado al portapapeles`, 'success', true)
    },
    onCopyError() {
        this.showMensaje(`Error al copiar texto al portapapeles`, 'error', true)
    },
    showMensaje(mensaje,color,multiline) {
      this.sb.mensaje = mensaje
      this.sb.multiline = multiline
      this.sb.color = color
      this.sb.mostrar = true
    },
  },
  mounted() {
    this.fecha_desde =  moment().format('YYYY-MM-DD');
  },
  created() {
  }
}
</script>
